import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogoacab() {



  const cardData = {
    keyword: " Mumbai to Goa Cabs ",

headingDescription: "Royal Route Cab offers reliable and comfortable Mumbai to Goa cab services, ensuring a smooth and scenic journey to one of Maharashtra’s most popular hill stations. Whether you are planning a family vacation, romantic getaway, weekend trip, or group tour, our professional drivers and well-maintained vehicles guarantee a safe and relaxing travel experience. The Mumbai to Mahabaleshwar route covers approximately 260 to 280 km and takes you through beautiful highways, ghats, and lush green landscapes. We provide flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted choice for Mumbai to Mahabaleshwar travel.",

topPlaces: [
  {
    title: "Baga Beach",
    description: "Baga Beach is one of Goa’s most popular beaches, known for its lively atmosphere, water sports, beach shacks, and vibrant nightlife. It is a favorite destination for tourists seeking both relaxation and entertainment."
  },
  {
    title: "Calangute Beach",
    description: "Calangute Beach, often called the Queen of Beaches, is famous for its golden sands, water activities, and bustling markets. It is one of the most visited beaches in Goa and ideal for families and groups."
  },
  {
    title: "Dudhsagar Waterfalls",
    description: "Dudhsagar Waterfalls is one of India’s tallest waterfalls, located amidst lush forests of the Western Ghats. The cascading white water creates a spectacular view, especially during the monsoon season."
  },
  {
    title: "Fort Aguada",
    description: "Fort Aguada is a well-preserved Portuguese fort overlooking the Arabian Sea. Built in the 17th century, it offers stunning coastal views and is one of Goa’s most important historical landmarks."
  },
  {
    title: "Basilica of Bom Jesus",
    description: "The Basilica of Bom Jesus is a UNESCO World Heritage Site and one of Goa’s most famous churches. It houses the mortal remains of Saint Francis Xavier and showcases magnificent Baroque architecture."
  },
  {
    title: "Anjuna Beach",
    description: "Anjuna Beach is known for its scenic beauty, vibrant flea market, and laid-back atmosphere. It attracts travelers from around the world looking for relaxation, shopping, and beachside entertainment."
  },
  {
    title: "Chapora Fort",
    description: "Chapora Fort offers breathtaking views of the Arabian Sea and Vagator Beach. Famous for its appearance in Bollywood movies, it is a popular destination for photography and sightseeing."
  },
  {
    title: "Vagator Beach",
    description: "Vagator Beach is known for its dramatic cliffs, red sands, and stunning sunsets. It provides a more peaceful experience compared to some of Goa’s busier beaches while offering beautiful ocean views."
  },
  {
    title: "Palolem Beach",
    description: "Palolem Beach is one of South Goa’s most beautiful beaches, known for its crescent-shaped shoreline, calm waters, and relaxed atmosphere. It is perfect for swimming, kayaking, and enjoying nature."
  },
  {
    title: "Se Cathedral",
    description: "Se Cathedral is one of the largest churches in Asia and a remarkable example of Portuguese-Gothic architecture. It is a significant religious and historical attraction in Old Goa."
  }
],





services: [
  {
    name: "Mumbai to Goa Cab",
    description: "Mumbai to Goa cab service offers a comfortable and scenic road trip experience to one of India’s most popular beach destinations. The journey is filled with lush greenery, coastal highways, and beautiful landscapes, making it enjoyable for travelers. This service is ideal for families, couples, and groups looking for a private and relaxed travel option. Professional drivers ensure safe and smooth driving on long routes. Multiple vehicle options including sedan, SUV, and luxury cars are available. It guarantees a memorable and stress-free journey."
  },
  {
    name: "Mumbai to Goa Car Rental",
    description: "Mumbai to Goa car rental provides flexible travel solutions for customers who prefer customized road trips. Travelers can choose from a wide range of vehicles depending on their comfort and group size. This service is perfect for vacations, family outings, and corporate trips. Easy booking and transparent pricing make it convenient. Vehicles are well-maintained for long-distance travel. It ensures a smooth and enjoyable journey."
  },
  {
    name: "Mumbai to Goa Taxi Fare",
    description: "Mumbai to Goa taxi fare is structured to provide transparent and competitive pricing for long-distance travel. The cost depends on vehicle type, travel duration, and trip preferences. Customers receive a clear fare breakdown including tolls and driver charges where applicable. Budget and premium options are available. It helps travelers plan their journey cost effectively. It ensures value for money."
  },
  {
    name: "Mumbai to Goa Taxi",
    description: "Mumbai to Goa taxi service offers reliable and comfortable travel with door-to-door pickup and drop. This service is ideal for travelers who prefer private transport over buses or trains. Vehicles are clean and driven by experienced chauffeurs. Flexible travel schedules add convenience. It is suitable for both leisure and business travel. It ensures a safe and relaxing journey."
  },
  {
    name: "Mumbai to Goa Cab Fare",
    description: "Mumbai to Goa cab fare is designed to be affordable and transparent for all travelers. Pricing varies based on car type, travel plan, and distance covered. Customers can choose from economical sedans to premium SUVs. No hidden charges ensure trust and reliability. It helps in planning a budget-friendly trip. It offers a cost-effective travel solution."
  },
  {
    name: "Mumbai to Goa Taxi One Way Fare",
    description: "Mumbai to Goa taxi one way fare is ideal for travelers looking for a single-side journey without return cost. This option is budget-friendly and suitable for those planning extended stays in Goa. Customers benefit from flexible pickup timings and competitive pricing. Comfortable vehicles and professional drivers ensure a smooth journey. It is perfect for economical travel."
  },
  {
    name: "Mumbai to Goa Cab Price",
    description: "Mumbai to Goa cab price depends on vehicle category, trip type, and travel duration. Transparent pricing ensures clarity for customers. Budget-friendly sedan options and premium SUV or luxury vehicles are available. Customers can select according to their comfort level. It helps in choosing the best travel option. It ensures a reliable and affordable journey."
  },
  {
    name: "Mumbai to Goa by Car Fare",
    description: "Mumbai to Goa by car fare offers flexible pricing options for private road trips. Travelers can enjoy a personalized journey with stops along scenic routes. The fare depends on car type, distance, and travel plan. Transparent pricing ensures no hidden costs. It is ideal for those who prefer a comfortable and private journey. It provides excellent travel value."
  },
  {
    name: "Book Cab from Mumbai to Goa",
    description: "Book cab from Mumbai to Goa easily with quick reservation options and instant confirmation. Customers can select their preferred vehicle, travel date, and pickup location. Online booking ensures a hassle-free experience with secure payment options. Dedicated support is available for assistance. It simplifies travel planning. It is the most convenient way to book your Goa trip."
  },
  {
    name: "Car Hire from Mumbai to Goa",
    description: "Car hire from Mumbai to Goa offers a flexible and personalized travel experience for long-distance journeys. This service is suitable for family vacations, group tours, and corporate trips. Travelers can choose from multiple vehicle options. Clean cars and professional drivers ensure comfort and safety. It allows customization of travel routes and stops. It ensures a relaxed journey."
  },
  {
    name: "Car on Rent from Mumbai to Goa",
    description: "Car on rent from Mumbai to Goa provides a convenient travel option for those seeking private transportation. Customers can rent cars for one-way or round trips based on their needs. Vehicles are maintained for long-distance travel performance. Easy booking and transparent pricing enhance convenience. It ensures a smooth and comfortable journey."
  },
  {
    name: "Mumbai Goa Cab Service",
    description: "Mumbai Goa cab service offers dependable transportation with a focus on safety, comfort, and punctuality. This service is ideal for tourists and corporate travelers. Vehicles are well-maintained and drivers are experienced in highway travel. Flexible pickup locations across Mumbai add convenience. It ensures a reliable and enjoyable travel experience."
  },
  {
    name: "Mumbai to Goa by Road Taxi Fare",
    description: "Mumbai to Goa by road taxi fare is designed for travelers planning a scenic road journey. Pricing includes distance, vehicle type, and travel duration. Transparent cost breakdown helps in better trip planning. Budget-friendly and premium options are available. It ensures clarity and affordability. It is ideal for road trip lovers."
  },
  {
    name: "Mumbai to Goa Cab Booking",
    description: "Mumbai to Goa cab booking allows travelers to reserve their ride with ease and flexibility. Customers can choose vehicle type, pickup location, and travel date. Instant confirmation and transparent pricing ensure a smooth booking process. Online and offline options are available. It is the easiest way to secure your travel. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Goa Cab Booking Price",
    description: "Mumbai to Goa cab booking price varies depending on car type, trip duration, and travel requirements. Customers are provided with clear and upfront pricing details. Budget-friendly and premium options are available. It helps travelers select the best option according to their needs. It ensures value-driven travel planning."
  },
  {
    name: "Mumbai to Goa Cab Charges",
    description: "Mumbai to Goa cab charges are structured to be competitive and transparent for all customers. Charges may include tolls, driver allowance, and distance-based fare. Clear pricing ensures no hidden costs. Multiple vehicle options are available to suit different budgets. It helps in planning an economical journey. It ensures trust and reliability."
  },
  {
    name: "Mumbai to Goa Cab Hire",
    description: "Mumbai to Goa cab hire service provides flexible travel options for individuals and groups. Customers can hire cabs for one-way or round trips with customizable travel plans. Vehicles are clean, comfortable, and driven by experienced chauffeurs. Easy booking process and reliable service enhance convenience. It ensures a comfortable and enjoyable journey."
  }
],

tableData: [
  ["Mumbai to Goa Cab", "Mumbai to Goa Car Rental"],
  ["Mumbai to Goa Taxi Fare", "Mumbai to Goa Taxi"],
  ["Mumbai to Goa Cab Fare", "Mumbai to Goa Taxi One Way Fare"],
  ["Mumbai to Goa Cab Price", "Mumbai to Goa by Car Fare"],
  ["Book Cab from Mumbai to Goa", "Car Hire from Mumbai to Goa"],
  ["Car on Rent from Mumbai to Goa", "Mumbai Goa Cab Service"],
  ["Mumbai to Goa by Road Taxi Fare", "Mumbai to Goa Cab Booking"],
  ["Mumbai to Goa Cab Booking Price", "Mumbai to Goa Cab Charges"],
  ["Mumbai to Goa Cab Hire", "Mumbai to Goa Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Goa Road Trip",
    WhyChoosedescription: "Royal Route Cabs offers a relaxing and enjoyable Mumbai to Goa cab service, perfect for beach holidays, family vacations, and long scenic drives."
  },
  {
    WhyChooseheading: "Expert Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Mumbai to Goa highway routes, ensuring safe driving, smooth navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Fare with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing for Mumbai to Goa cab bookings including tolls, driver allowance, and all charges with full transparency."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai to Goa cab service operates 24/7, allowing you to start your journey anytime as per your convenience."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, regularly maintained, and cleaned to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day Goa travel packages based on your travel needs."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "Royal Route Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, luxury cars, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by many travelers for Mumbai to Goa cab bookings due to punctual service, professional drivers, and customer satisfaction."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Goa cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Goa for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Goa?", answer: "The distance is approximately 580 to 620 km and the journey takes around 10 to 12 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Goa cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, luxury cars, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, and airports across Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and holiday seasons." },
  { question: "Is the route safe for travel?", answer: "Yes, our experienced drivers ensure safe travel on highways and ghats during the journey." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Deshmukh",
    feedback: "The Mumbai to Goa cab journey with Royal Route Cabs was very comfortable and enjoyable. The highway drive was smooth and the driver ensured a safe trip throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Patil",
    feedback: "Excellent experience traveling from Mumbai to Goa. The cab was clean, the ride was relaxing, and the service felt reliable and well-organized.",
    rating: 5
  }
];
























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Goa Cabs",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-goa-cab.jpg", // replace if needed
  "description": "Book Mumbai to Goa cab with Royal Route Cabs for a smooth and affordable road trip. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip travel. Enjoy safe, comfortable rides with experienced drivers and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7000", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-goa-cabs"
  }
};



  return (
    <div>

<Helmet>
  <title>Mumbai to Goa Cabs | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Goa cabs at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available for long-distance travel."
  />

  <meta
    name="keywords"
    content="mumbai to goa cab, mumbai to goa car rental, mumbai to goa taxi fare, mumbai to goa taxi, mumbai to goa cab fare, mumbai to goa taxi one way fare, mumbai to goa cab price, mumbai to goa by car fare, book cab from mumbai to goa, car hire from mumbai to goa, car on rent from mumbai to goa, mumbai goa cab service, mumbai to goa by road taxi fare, mumbai to goa cab booking, mumbai to goa cab booking price, mumbai to goa cab charges, mumbai to goa cab hire, mumbai to goa cab rates, mumbai to goa cab service, mumbai to goa cab service fare, mumbai to goa car booking, mumbai to goa car hire, mumbai to goa car rental with driver, mumbai to goa car service, mumbai to goa one way cab, mumbai to goa one way taxi, mumbai to goa taxi price, mumbai to goa taxi rate, mumbai to goa taxi service, taxi service from mumbai to goa, mumbai airport to goa cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/3.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitogoacab;